import { DateTime } from "luxon";

/**
 *
 * @param {MonthlyOfferCategoryData[]} offersCountData - Données des offres par catégorie par mois
 * @param {DateTime} afterDate  - Date de début (type DateTime de Luxon)
 * @param {DateTime} beforeDate - Date de fin (type DateTime de Luxon)
 * @returns {NivoBarChartData}
 */
export function getOffersPublishedByMonthData(
  offersCountData,
  afterDate = 0,
  beforeDate = 0
) {
  // Par défaut on prend les 6 derniers mois (hors actuel)
  if (afterDate === 0)
    afterDate = DateTime.local()
      .startOf("month")
      .minus({ months: 6 })
      .plus({ days: 1 });
  else afterDate = DateTime.fromJSDate(afterDate);
  if (beforeDate === 0)
    beforeDate = DateTime.local().endOf("month").minus({ months: 1 });
  else beforeDate = DateTime.fromJSDate(beforeDate);

  /* Nombre de mois entre la date de début et la date de fin */
  let differential = Math.round(
    Math.abs(beforeDate.diff(afterDate, "months").values.months)
  );

  const chartData = [];

  //? Pour chaque mois on crée un objet
  for (let j = 0; j < differential; ++j) {
    const currentMonth = afterDate
      .plus({ month: j })
      .setLocale("fr")
      .toFormat("MM-yyyy");
    chartData.push({
      date: currentMonth,
    });
  }

  for (let j = 0; j < chartData.length; ++j) {
    const currentMonth = chartData[j].date;
    const monthData = offersCountData.find((data) =>
      Object.prototype.hasOwnProperty.call(data, currentMonth)
    );
    if (monthData !== undefined) {
      const offersCategories = monthData[currentMonth];
      const monthObject = { date: currentMonth };
      monthObject["Offres"] = 0;
      offersCategories.forEach((category) => {
        monthObject["Offres"] += category.total;
      });
      chartData[j] = monthObject;
    }
  }
  return chartData;
}
